export function intersect(set1, set2) {
    let intersected = new Set();
    let values = Array.from(set1);
    for (let i in values) {
        if (set2.has(values[i])) {
            intersected.add(values[i]);
        }
    }
    return intersected;
}

